//@flow
import { asyncComponent } from 'react-async-component'
import LoadingComponent from '../../LoadingComponent'
import ErrorComponent from '../../ErrorComponent'

const DragAndDropGroup = asyncComponent({
  resolve: () => import('./DragAndDropGroup'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDragAndDropGroup',
})

const DragAndDrop = asyncComponent({
  resolve: () => import('./DragAndDrop'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDragAndDrop',
})

const DragAndDropHome = asyncComponent({
  resolve: () => import('./DragAndDropHome'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDragAndDropHome',
})

const DragAndDropTarget = asyncComponent({
  resolve: () => import('./DragAndDropTarget'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDragAndDropTarget',
})

export { DragAndDrop, DragAndDropGroup, DragAndDropHome, DragAndDropTarget }



// WEBPACK FOOTER //
// ./src/components/QuestionElements/DragAndDrop/index.js